import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = {
	root: {
		width: '1em',
		height: '1em',
		display: 'inline-block',
	}
}

const PolygonIcon = ({ classes }) => (
	<svg viewBox="0 0 24 24" className={classes.root}>
	    <path
	    	d = "M 6 4 L 3 19 L 20 21 L 19 9 L 6 4"
	    	strokeWidth = "2"
	    	fill = "transparent"
	    	stroke = "currentColor"
	    	strokeLinecap = "round"
	    	strokeDasharray = "1 3">
	    </path>
	</svg>

)

export default withStyles(styles)(PolygonIcon)



// WEBPACK FOOTER //
// ./src/components/MapMenu/PolygonIcon.js